module.exports = __webpack_public_path__ + "static/media/Banner1_mob_new.a5f9193e.png";